import shareExportsModalController from "./shareExportsModal.controller";
import editDownloadModalController from "./editDownloadModal.controller"

export default /*@ngInject*/ function ($filter, authenticationService, ExportReportService, $uibModal, myDownloadsDataService) {

    const vm = this;

    vm.determineStatusLabelClass = determineStatusLabelClass;
    vm.setExportingOpacity = setExportingOpacity;
    vm.deleteExport = deleteExport;
    vm.downloadItemClicked = downloadItemClicked;
    vm.downloadItem = downloadItem;
    vm.clearObjectSelection = clearObjectSelection;
    vm.openEditDownloadModal = openEditDownloadModal;
    vm.changeRadioFilter = changeRadioFilter;
    vm.selectDownload = selectDownload;
    vm.selectAllDownloads = selectAllDownloads;
    vm.checkSelectAll = checkSelectAll;
    vm.exportsAreLoading = false;
    vm.showFilters = false;
    vm.selectMultiple = false;
    vm.exportIds = { ExportIds: [] };
    vm.menuOptions = [
        {
            text: 'Download',
            click: function ($itemScope, $event, modelValue) {
                downloadItem(modelValue);
            },
            displayed: function ($itemScope, $event, modelValue) {
                return (modelValue.Status === 'ReadyForDownload' || modelValue.Status === 'Downloaded');
            }
        },
        {
            text: 'Edit',
            click: function ($itemScope, $event, modelValue) {
                openEditDownloadModal(modelValue);
            },
            displayed: function (modelValue) {
                return (modelValue.exportItem.Owner.UserLogonName === vm.userName);
            },
            hasTopDivider: true
        },
        {
            text: 'Share Export',
            click: function (modelValue) {
                openShareExportModal(modelValue.exportItem);
            },
            displayed: function (modelValue) {
                return (modelValue.exportItem.Owner.UserLogonName === vm.userName);
            }
        },
        {
            text: '<span class="text-danger">Delete</span>',
            click: function ($itemScope, $event, modelValue) {
                deleteExport(modelValue);
            },
            displayed: function (modelValue) {
                return (modelValue.exportItem.Owner.UserLogonName === vm.userName);
            }
        }
    ];

    activate();

    async function activate() {
        await getExports();
        getExportsSharedWithUser();
        vm.selectedDownloads = [];
        vm.downloadsRadioFilter = 1;
    }

    async function getExports() {
        vm.exportsAreLoading = true;

        try {
            vm.currentUser = await authenticationService.getUser();
            vm.userName = vm.currentUser.fullName;
            let { data } = await myDownloadsDataService.getExports(vm.currentUser.userId);
            data = $filter('orderBy')(data, 'CreatedOn', 'desc');

            vm.listOfExports = data;
            vm.myDownloads = [...vm.listOfExports];

            vm.exportsAreLoading = false;
        } catch {
            vm.exportsAreLoading = false;
        }
    }

    async function getExportsSharedWithUser() {
        vm.exportsAreLoading = true;
        vm.listOfSharedExports = [];

        try {
            let { data } = await myDownloadsDataService.getExportsSharedWithUser(vm.currentUser.userId);
            data = $filter('orderBy')(data, 'CreatedOn', 'desc');

            vm.listOfSharedExports = data;

            // Only show filter bar if there are downloads shared with user
            if (vm.listOfSharedExports.length > 0) {
                vm.showFilters = true;
            } else {
                vm.showFilters = false;
            }

            if (vm.downloadsRadioFilter === 0) {
                changeRadioFilter('Shared With Me');
            }

            vm.exportsAreLoading = false;
        } catch {
            vm.exportsAreLoading = false;
        }
    }

    function determineStatusLabelClass(ActionName) {
        if (ActionName === 'Excel') {
            return 'excel-file-icon';
        } else if (ActionName === 'PDF') {
            return 'pdf-file-icon';
        } else if (ActionName === 'Csv') {
            return 'csv-file-icon';
        }
    }

    function setExportingOpacity(status) {
        if (status === 'Exporting') {
            return 'file-exporting-opacity';
        }
    }

    async function deleteExport(item) {
        vm.exportsAreLoading = true;
        vm.exportIds.ExportIds = vm.selectedDownloads.map(item => item.Id);
        try {
            if (vm.selectMultiple) {
                await myDownloadsDataService.deleteMultiple(vm.exportIds);
            } else {
                await myDownloadsDataService.deleteExport(item.Id);
            }

            await getExports();
            getExportsSharedWithUser();
            clearObjectSelection();

            if (!vm.listOfExports.length) {
                vm.selectMultiple = false;
            }
        } catch {
            return;
        }
    }

    function downloadItemClicked(item) {
        if (item.Status !== 'Error' && !vm.selectMultiple && item.Status !== 'Exporting') {
            downloadItem(item);
        } else {
            return;
        }
    }

    async function downloadItem(item) {
        vm.exportsAreLoading = true;
        vm.noErrorDownloadItems = vm.selectedDownloads.filter(download => download.Status !== 'Error');
        vm.exportIds.ExportIds = vm.noErrorDownloadItems.map(item => item.Id);

        try {
            if (vm.selectMultiple) {
                await myDownloadsDataService.downloadMultiple(vm.exportIds, vm.noErrorDownloadItems);
            } else {
                ExportReportService.downloadReportExport(item);
            }
            await getExports();
            getExportsSharedWithUser();
            clearObjectSelection();
        } catch {
            clearObjectSelection();
        }
    }

    async function openShareExportModal(modelValue) {
        let shareExportModal = await $uibModal.open({
            templateUrl: '/App/Components/myDownloads/shareExportsModal.tmpl.html',
            controller: shareExportsModalController,
            controllerAs: 'semvm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
                modelValue: () => modelValue
            }
        });

        try {
            await shareExportModal.result;
            await getExports();
            getExportsSharedWithUser();
        } catch {
            return;
        }
    }

    async function openEditDownloadModal(modelValue) {
        let editDownloadModal = await $uibModal.open({
            templateUrl: '/App/Components/myDownloads/editDownloadModal.tmpl.html',
            controller: editDownloadModalController,
            controllerAs: 'edmvm',
            backdrop: 'static',
            resolve: {
                modelValue: () => modelValue
            }
        });

        try {
            await editDownloadModal.result;
            await getExports();
            getExportsSharedWithUser();
        } catch {
            return;
        }
    }

    function selectDownload(download) {
        if (download.selected) {
            vm.selectedDownloads.push(download);
        } else {
            vm.selectedDownloads.splice(vm.selectedDownloads.indexOf(download), 1);
        }

        checkSelectAll();

    }

    function checkSelectAll() {
        vm.allDownloadsSelected = vm.listOfExports.every(item => item.selected);
    }
    function selectAllDownloads() {
        vm.listOfExports.forEach(item => {
            if (item.Status !== 'Exporting') {
                if (vm.searchBoxSelectedObjects) {
                    if (item.Name.toUpperCase().includes(vm.searchBoxSelectedObjects.toUpperCase())) {
                        item.selected = vm.allDownloadsSelected;
                    }
                } else {
                    item.selected = vm.allDownloadsSelected;
                }
            }
        });

        vm.selectedDownloads = vm.listOfExports.filter(item => item.selected);
    }

    function clearObjectSelection() {
        vm.listOfExports.forEach(item => item.selected = false);           
        vm.selectedDownloads = [];
        vm.allDownloadsSelected = false;
    }

    function changeRadioFilter(type) {
        switch (type) {
            case 'My Downloads':
                vm.listOfExports = vm.myDownloads;
                clearObjectSelection();
                break;
            case 'Shared With Me':
                //When case type is 'Shared With Me', push each object to new array and assign proper values so Object Names align with 'vm.listOfExports' list - this ensures that the html works/displays cohesively
                vm.listOfExports = vm.listOfSharedExports.reduce((newList, row) => {
                    newList.push({
                        Id: row.ExportId,
                        Name: row.ExportName,
                        Status: row.ExportStatus,
                        CreatedOn: row.CreatedOn,
                        Type: row.ExportType,
                        Owner: {
                            UserLogonName: row.OwnerName
                        }
                    });
                    return newList;
                }, []);
                clearObjectSelection();
                break;
            default:
                break;
        }
    }
}